import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import AssessmentQuestionsAdminSection from './sections/assessmentQuestionsAdminSection';
import TalentProfilesAdminSection from './sections/talentProfilesAdminSection';
import TalentDimensionsAdminSection from './sections/talentDimensionsAdminSection';

import { questions } from '../../data/questions';
import { talentProfiles } from '../../data/talentProfiles';
import { dimensions } from '../../data/dimensions';

import {
  getIcon,
  currentUserIsSuperAdmin,
  toTitleCase,
  getCategoryNameFromId,
} from '../../util';


import {
  updateAppConfig,
  updateLatestAssessmentVersion,
  fetchAssessmentVersions,
} from '../../actions/admin';

import AppConfigCustomSidebar from './appConfigCustomSidebar';

import { Page } from '../shared';

import Select from 'react-select';

class AdminPage extends Component {

  state = {
    pageMessage: null,
    currentView: 'general',

    cachedConfig: null,
    updatedConfig: null,

    renderTooltipsForQuestionId: null,
    unsavedChanges: false,
    appConfigAndAssessmentQuestionsLoaded: false,
  }

  loadDefaultQuestions(){
    this.props.updateLatestAssessmentVersion({
      questions,
      versionLabel: '1.0'
    });
  }

  componentDidMount(){
    // this.loadDefaultQuestions();

    this.props.fetchAssessmentVersions();
  }

  mapConfig(appConfig){
    const mappedConfig = {
      talentProfiles: appConfig.talentProfiles,
      talentDimensions: appConfig.talentDimensions,
      localizations: appConfig.localizations,
    }

    return _.cloneDeep(mappedConfig);
  }

  componentDidUpdate(prevProps, prevState){
    const pageTab = this.props.match.params.pageTab || 'general';

    if(this.state.currentView !== pageTab){
      this.setState({
        currentView: pageTab,
      });
    }

    if(!this.state.appConfigAndAssessmentQuestionsLoaded && this.props.appConfig){

      const mappedConfig = this.mapConfig(this.props.appConfig);
      const mappedConfigCopy = this.mapConfig(this.props.appConfig);

      this.setState({
        appConfigAndAssessmentQuestionsLoaded: true,
        cachedConfig: mappedConfig,
        updatedConfig: mappedConfigCopy,
      });
    }

    //if done saving changes - set unsavedchanges to false immediately
    if(!this.props.savingAppConfig && prevProps.savingAppConfig && this.state.unsavedChanges){
      this.setState({
        unsavedChanges: false
      });
    }
  }

  getPageTitle(){
    const { currentView } = this.state;

    switch(currentView){
      default:
      case 'general':
        return 'General Options';
      case 'talentProfiles':
        return 'Manage Talent Profiles';
      case 'talentDimensions':
        return 'Manage Talent Dimensions';
      case 'assessmentOrdering':
        return 'Manage Assessment & Question Ordering';
      case 'assessmentQuestions':
        return 'Manage Assessment Questions';
      case 'organizations':
        return 'Manage Organizations';
      case 'permissions':
        return 'Manage Users & Permissions';
    }
  }

  renderTalentProfilesSection(){
    return (
      <div className="page-section">
        <p>Talent profiles define a subset of talent evaluation questions that applies to a specific job family, such as "Sales Manager" or "Account Manager". Organizations will be able to assign their own names for these job families.</p>
        <TalentProfilesAdminSection
          appConfig={this.state.updatedConfig}
          />
      </div>
    )
  }

  renderTalentDimensionsSection(){
    return (
      <div className="page-section">
        <p>Talent dimensions define how talent questions and skills questions map to a user's talent dimensions profile. Organizations will be able to assign their own names for these dimensions. Dimension labeling can be consistent across all talent profiles, or can be customized by talent profile.</p>
          <TalentDimensionsAdminSection
            appConfig={this.state.updatedConfig}
            />
      </div>
    )
  }
  renderAssessmentOrderingSection(){
    return (
      <div className="page-section">
        <p>For now this is static. Order is 1) Skills Questions, 2) Talent Questions, 3) Experience (SJT) Questions, 4) Open Ended Questions</p>
      </div>
    )
  }


  renderAssessmentQuestionsSection(){

    if(!this.props.assessmentVersions || !this.state.updatedConfig){
      return null;
    }

    return(
      <div className="page-section">
        <AssessmentQuestionsAdminSection
          assessmentVersions={this.props.assessmentVersions}
          appConfig={this.state.updatedConfig}
          updateLatestAssessmentVersion={this.props.updateLatestAssessmentVersion}
          saving={this.props.savingAssessmentVersions}
        />
      </div>
    )
  }

  discardChanges(){
    const cachedConfigCopy = _.cloneDeep(this.state.cachedConfig);

    this.setState({
      updatedConfig: cachedConfigCopy,
      unsavedChanges: false,
    });
  }

  saveChanges(){

    let assessmentQuestions = {};

    _.each(this.state.updatedConfig.assessmentQuestions, question => {

      let questionWithoutLocalProps = { ...question };
      delete questionWithoutLocalProps.searchString;
      delete questionWithoutLocalProps.dimensionName;
      delete questionWithoutLocalProps.categoryName;

      assessmentQuestions[question.id] = questionWithoutLocalProps;
    });
    const talentProfiles = this.state.updatedConfig.talentProfiles;

    const updatedConfig = {
      talentProfiles,
      assessmentQuestions,
    }

    this.props.updateAppConfig({
      ...updatedConfig
    }, () => {
      this.setState({
        cachedConfig: this.mapConfig(updatedConfig),
        updatedConfig: this.mapConfig(updatedConfig),
        unsavedChanges: false
      });
    });
  }

  renderUnsavedChanges(){

    const { unsavedChanges } = this.state;
    const { savingAppConfig } = this.props;

    return (
      <div className={`unsaved-page-changes ${unsavedChanges ? 'visible' : ''}`}>
        <p>App configuration has unsaved changes...</p>
        <div className="actions">
          <button
            onClick={() => { this.discardChanges(); }}
            className="action discard">Discard</button>
          <button
            disabled={savingAppConfig}
            onClick={() => { if(savingAppConfig){ return } this.saveChanges(); }}
            className="action save">{savingAppConfig ? 'Saving...' : 'Save Changes'}</button>
        </div>
      </div>
    )
  }

  render(){

    const { currentView } = this.state;

    const { pageTab } = this.props.match.params;

    if(!pageTab){
      return <Redirect to="/settings/general" />;
    }

    return (
      <Page
        pageClass="admin"
        permissionRequired="manage_global_settings"
        loading={!this.props.appConfig}
        customSidebar={<AppConfigCustomSidebar />}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderUnsavedChanges()}

        <div className="page-title">
          <h1>{this.getPageTitle()}</h1>
        </div>
        {currentView === 'talentProfiles' && this.renderTalentProfilesSection()}
        {currentView === 'talentDimensions' && this.renderTalentDimensionsSection()}
        {currentView === 'assessmentOrdering' && this.renderAssessmentOrderingSection()}
        {currentView === 'assessmentQuestions' && this.renderAssessmentQuestionsSection()}

      </Page>
    );
  }
}


function mapStateToProps(state){
  return {
    appConfig: state.appConfig.data,
    savingAppConfig: state.appConfig.saving,
    assessmentVersions: state.assessmentVersions.data,
    savingAssessmentVersions: state.assessmentVersions.saving,
  }
}

export default connect(mapStateToProps, { updateAppConfig, updateLatestAssessmentVersion, fetchAssessmentVersions })(AdminPage);



// WEBPACK FOOTER //
// ./src/components/admin/index.js